import React, {useMemo} from "react";
import {Stack, TextField} from "@mui/material";
import ColorPicker from "../../components/color-picker/ColorPicker";
import {NeighbourhoodForm} from "../../api/Model";
import {formPatcher, inputChange, SetState} from "../../util/FormHandlers";

export function NeighbourhoodFormComponent({form, setForm}: {
    form: NeighbourhoodForm,
    setForm: SetState<NeighbourhoodForm>,
}) {
    const handlers = useMemo(() => ({
        handleNameChange: inputChange(setForm, newValue => ({
            name: newValue,
        })),
        handleNotesChange: inputChange(setForm, newValue => ({
            notes: newValue || undefined,
        })),
        handleColorChange: formPatcher(setForm, (newValue: string) => ({
            displayColor: newValue,
        })),
        handleSlackChannelIdChange: inputChange(setForm, newValue => ({
            slackChannelId: newValue || undefined,
        })),
    }), [setForm]);

    return form ? (
        <Stack spacing={2} direction="column" sx={{pt: 2}}>
            <TextField
                required
                autoFocus
                margin="dense"
                id="name"
                label="Neighbourhood Name"
                type="text"
                fullWidth
                variant="outlined"
                value={form.name}
                onChange={handlers.handleNameChange}
            />
            <ColorPicker
                margin="dense"
                id="displayColor"
                label="Display Color"
                fullWidth
                variant="outlined"
                value={form.displayColor || ''}
                onChange={handlers.handleColorChange}
                slotProps={{inputLabel: {shrink: true}}}
            />
            <TextField
                margin="dense"
                id="notes"
                label="Notes"
                type="text"
                fullWidth
                variant="outlined"
                multiline
                rows={3}
                value={form.notes || ''}
                onChange={handlers.handleNotesChange}
            />
            <TextField
                margin="dense"
                id="slackChannelId"
                label="Slack Channel ID"
                type="text"
                fullWidth
                variant="outlined"
                value={form.slackChannelId || ''}
                onChange={handlers.handleSlackChannelIdChange}
            />
        </Stack>
    ) : null;
}
